import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { Loading } from "../../Components/Loading"
import { IAccountSubscriptionStatus } from "../../Types"
import { AccountSettingsPlanViewProps } from "./Params"

// Remaining trial days for a trial subscription status, or null when the account
// is not on a trial (e.g. active, cancelled, expired).
function trialDaysRemaining(status?: IAccountSubscriptionStatus): number | null {
  switch (status) {
    case IAccountSubscriptionStatus.trial1DayLeft: return 1;
    case IAccountSubscriptionStatus.trial2DaysLeft: return 2;
    case IAccountSubscriptionStatus.trial3DaysLeft: return 3;
    case IAccountSubscriptionStatus.trial4DaysLeft: return 4;
    case IAccountSubscriptionStatus.trial5DaysLeft: return 5;
    case IAccountSubscriptionStatus.trialStarted: return 5;
    default: return null;
  }
}

export function AccountSettingsPlanView({ accountPlan, available, showPlans }: AccountSettingsPlanViewProps) {
  const app = GetApp();
  const t = app.getT("AccountSettingsView");

  const trialDays = trialDaysRemaining(app.account?.subscriptionStatus);
  const isTrial = trialDays !== null;

  return (
    <Block className="subscription-plan-block">
      <BlockRow>
        <BlockField>
          <button className="button" onClick={() => showPlans()}>
            {t("plans")}
          </button>
        </BlockField>
      </BlockRow>
      {app.cloudSession() && available && (
        <>
          <BlockRow>
            <h3>{t("subscription")}</h3>
          </BlockRow>
          {accountPlan ? (
            <>
              <BlockRow className="account_data_row">
                <BlockField label={t("plan")} className="block_field_small_12">
                  <input defaultValue={app.t(`AccountView_plan_${accountPlan}`)} name="plan" readOnly={true} />
                </BlockField>
              </BlockRow>
              {isTrial ? (
                <BlockRow className="account_data_row">
                  <BlockField label={t("trial_days_remaining")} className="block_field_small_12">
                    <input defaultValue={t("trial_days_value", { days: trialDays })} name="trial_days" readOnly={true} />
                  </BlockField>
                </BlockRow>
              ) : (
                app.account && app.account.nextBillingAt && (
                  <BlockRow className="account_data_row">
                    <BlockField label={t("valid_until")} className="block_field_small_12">
                      <input defaultValue={app.format("date", app.account.nextBillingAt)} name="valid_until" readOnly={true} />
                    </BlockField>
                  </BlockRow>
                )
              )}
            </>
          ) : <Loading />}
        </>
      )}
    </Block>
  );
}
